import * as React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
    backgroundColor: grey[800],
    border: 0,
    color: grey[400],
    height: theme.footerHeight + 16,
    lineHeight: `${theme.footerHeight}px`,
    padding: '16px 30px 0 30px',
    letterSpacing: '0.7px',
    '& a': {
      display: 'inline-block',
      marginRight: 15,
      fontSize: '0.8em',
    },
    [theme.breakpoints.down('sm')]: {
      lineHeight: 2,
      textAlign: 'center',
      paddingTop: 0,
      minHeight: theme.footerHeight + 32,
      height: 'auto',
      '& a': {
        marginTop: 5,
        display: 'block'
      }
    }
  },
  link: {
    color: grey[400],
    textDecoration: 'underline'
  },
  col2: {
    textAlign: 'right',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    }
  }
}));

export default function Footer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  if( props.hideXS && matches ) return <></>;

  return (
    <Box className={classes.root}>
      <Container>
        <Grid container>
          <Grid item xs={12} sm={4}>
            &copy; RecruitVirtual 2020
          </Grid>
          <Grid item xs={12} sm={8} className={classes.col2} >
            <Link className={classes.link} href='https://www.recruitvirtual.com/privacy-and-terms' rel="noopener" target='_blank'>Privacy Policy and Terms of Service</Link><Link className={classes.link} href='https://www.recruitvirtual.com/do-not-sell-my-personal-information/' rel="noopener" target='_blank'>Do not sell my personal information</Link>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
